export const SAVE_OFFERS = "discountDisclaimer_saveOffers";
export const DEFAULT = "discountDisclaimer";
